// extracted by mini-css-extract-plugin
module.exports = {"widgetLoader":"WidgetLoader_widgetLoader__3DEc7"};